//const env = process.env.NODE_ENV;
// const baseURL = env === 'development' ? 'http://localhost:7074' : '';
const baseURL = '';

// const baseURL = env === 'development' ? 'http://172.23.22.151:7074' : '';

const api = '/api';

const version = '/v1';



export const get_FetchPortletList = baseURL + api + version + '/portlets';

export const post_CreatePortletForm = baseURL + api + version + '/portlets';

export const post_CreatePortletFile = baseURL + api + version + '/portlets/upload';


export const get_GetPortlet = (id) => {
  return baseURL + api + version + '/portlets/' + id;
}

export const post_UpdatePortletForm = (id) => {
  return baseURL + api + version + '/portlets/' + id;
}

export const post_UpdatePortletFile = (id) => {
  return baseURL + api + version + '/portlets/' + id + '/upload';
}





// WEBPACK FOOTER //
// ./src/config/urls.js